<template>
	<v-app-bar
		app
		height="60"
		color="white"
		flat
		elevation="0"
	>
		<v-spacer v-if="$vuetify.breakpoint.smAndUp"/>
		<router-link :to="{ name: 'home' }" class="d-block white--text">
			<v-img
				src="@/assets/logo.png"
				height="60"
				:max-width="$vuetify.breakpoint.smAndUp ? 180 : 160"
			/>
		</router-link>
		<v-spacer/>

		<v-btn
			text
			@click="$i18n.locale = $i18n.locale === 'ar' ? 'en' : 'ar'"
		>
			<v-icon size="22" class="me-2">mdi-earth</v-icon>
			{{$i18n.locale === 'ar' ? 'en' : 'ar'}}
		</v-btn>
	</v-app-bar>
</template>

<script>
export default {
	name: 'Navbar',
};
</script>

<style>
</style>